<footer class="ipm-footer" [class.has-sale-banner]="showSaleBanner">
    <!-- Diwali Pro offer, part of the footer (while the sale is live; hidden for users already on Pro Annual) -->
    <section class="ipm-footer-sale" *ngIf="showSaleBanner">
        <div class="ipm-footer-sale-text">
            <div class="ipm-footer-sale-head">
                <h2 class="ipm-footer-sale-heading">
                    <span class="ipm-footer-sale-lamp">🪔</span>
                    <span class="ipm-footer-sale-brand">Beat22</span>
                    <span class="ipm-footer-sale-diwali">Diwali Sale</span>
                </h2>
                <span class="ipm-footer-sale-pill" *ngIf="saleEndAt">Ends {{saleEndAt | date : 'd MMM'}}</span>
            </div>
            <p class="ipm-footer-sale-title">Start Selling with Pro — 45% Off This Diwali</p>
        </div>
        <div class="ipm-footer-sale-actions">
            <span class="ipm-footer-sale-old-price">₹{{proPlanPrice | number}}</span>
            <button type="button" class="btn ipm-footer-sale-cta" (click)="openProPlans()">Subscribe Pro for ₹{{proPlanSalePrice | number}}</button>
        </div>
    </section>
    <div class="ipm-main-section">
        <!--MOBILE-VIEW-->
        <div class="ipl-search-section ipm-footer-mob-search-box">
            <input type="search" class="form-control" placeholder="Search top beats"
                id="seach-mobile-footer"
                [(ngModel)]="commonService.selectedSearchInputValue"
                (search)="onChangeSearchValue($event)"
                (keydown.enter)="onChangeSearchValue($event)"
                [ngModelOptions]="{standalone: true}"
                aria-label="Search filter"
                name="search-footer">
                <p-dropdown
                        id="searchFilter" [options]="commonService.searchFilterType"
                        [(ngModel)]="commonService.selectedSearchType"
                        optionLabel="label"
                        aria-label="Search filter"
                        (ngModelChange)="commonService.selectedSearchInputValue? onChangeSearchValue($event) : ''"
                        [ngModelOptions]="{standalone: true}" placeholder="" [className]="'ipm-dropdown'">
                </p-dropdown>
        </div>
        <div class="ipm-left-section">
            <div class="ipm-logo-section">
                <img priority priority [src]="mainLogoImageUrl" alt="ipm-logo" width="166" height="45">
                <button class="btn ipm-start-selling" mat-raised-button (click)="openBeatSelling()"
                *ngIf="!currentUserDetails || (currentUserDetails && currentUserDetails.role !== 'producer')"> Start Selling</button>
            </div>
            <div class="ipm-menu-list">
                <ng-container *ngFor="let menu of menuList; let i = index">
                    <div class="menu-section" *ngIf="menu?.menuList.length > 0">
                        <h4 >{{menu?.heading}}</h4>
                        <ul *ngFor="let  subList of menu?.menuList">
                            <li><a (click)="handleNavigationClick(menu?.heading, subList)" role="button">{{subList.name}}</a></li>
                        </ul>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="ipm-right-section">
            <div class="ipl-search-section ipm-footer-desktop-search-box">
                <input type="search" class="form-control"
                    placeholder="Search top beats"
                    id="seach-footer"
                    [(ngModel)]="commonService.selectedSearchInputValue"
                    (search)="onChangeSearchValue($event)"
                    (keydown.enter)="onChangeSearchValue($event)"
                    [ngModelOptions]="{standalone: true}"
                    aria-label="Search filter"
                    name="search-footer">
                    <p-dropdown id="searchFilter" [options]="commonService.searchFilterType" [(ngModel)]="commonService.selectedSearchType" optionLabel="label" aria-label="Search filter" placeholder="" [className]="'ipm-dropdown'">
                    </p-dropdown>
            </div>
            <p>We accept following payment systems</p>
            <div class="cards-section">
                <ng-container *ngFor="let paymentIcon of paymentList; let i = index;">
                    <div class="payment-box">
                        <img class='payment-icons' [alt]="'card_'+i" [id]="'card_'+i" priority priority [src]="'https://ip-dev.s3.ap-south-1.amazonaws.com/assets/imgs/footer-icons/'+paymentIcon">
                    </div>
                </ng-container>
            </div>
            <div class="ipl-follow-section">
                <p>Follow Us</p>
                <ul>
                    <li>
                        <a href="https://www.facebook.com/Beat22app" target="_blank" aria-label="Facebook">
                            <i class="lab la-facebook-f"></i>
                        </a>
                    </li>
                    <li>
                        <a href="Https://instagram.com/beat22__" target="_blank" aria-label="instagram">
                            <i class="lab la-instagram"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://x.com/beat22__" target="_blank" aria-label="twitter">
                            <i class="lab la-twitter"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/@beat22app" target="_blank" aria-label="YouTube">
                            <i class="lab la-youtube"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="ipm-copy-rights">
        <p>Ill People Productions Private Limited</p>
        <p>{{currentYear}} All Rights Reserved</p>
    </div>
</footer>
